import styled from 'styled-components';
import DefaultContainer from '../../assets/styles/DefaultContainer';

export const Container = styled(DefaultContainer)`
  background: ${({ theme }) => theme.colors.gradient[180]};
  position: relative;
  overflow: hidden;
  background-color: red;

  > img {
    width: 100%;
  }
`;
